import { render, staticRenderFns } from "./CoverView.vue?vue&type=template&id=4dad2e7d&scoped=true"
import script from "./CoverView.vue?vue&type=script&lang=js"
export * from "./CoverView.vue?vue&type=script&lang=js"
import style0 from "./CoverView.vue?vue&type=style&index=0&id=4dad2e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad2e7d",
  null
  
)

export default component.exports